module.exports = __webpack_public_path__ + "img/success.929a1bfb.svg";